import { API_ENDPOINT } from "@/utils/general";

export async function sendMessage({
  message,
  captchaResponse,
}: {
  message: string;
  captchaResponse: unknown;
}): ReturnType<typeof fetch> {
  console.info("Sending message", { message, captchaResponse });
  const resp = await fetch(API_ENDPOINT + "/purple-radio/messages", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ message, captchaResponse }),
  });

  try {
    if (!resp.ok) {
      const jsonBody = await resp.json();
      throw new Error("Network response was not ok" + JSON.stringify(jsonBody));
    }
  } catch (e) {
    throw new Error("Network request failed!");
  }
  return resp;
}

export const sendRating = function (rating) {
  try {
    // purposefully allow failure here (i.e. not .?) so can be caught
    // ask for forgiveness
    window["gtag"]("event", "rate_show", { rating });
  } catch (e) {
    console.error("Failed to rate show", e);
  }
};
